<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- Start:: Mark All As Read Button -->
      <div
        class="mark_all_read_wrapper"
        v-if="receivedMessages.length && hasUnreadMessages"
      >
        <base-button
          class="mark_all_read_btn"
          styleType="primary_btn"
          :btnText="$t('BUTTONS.markAllAsRead')"
          :isLoading="isMarkingAllAsRead"
          :disabled="isMarkingAllAsRead"
          @fireClick="markAllAsRead"
        />
      </div>
      <!-- End:: Mark All As Read Button -->

      <form>
        <transition-group name="fade" v-if="receivedMessages.length">
          <div
            class="notification"
            :class="{
              read: message.is_read == true,
              clickable: !message.is_read || hasRedirectPath(message),
            }"
            v-for="(message, index) in receivedMessages"
            :key="'k' + index"
            @click="handleNotificationClick($event, message)"
          >
            <div v-if="message?.type != 'delete_account'">
              <h3>{{ message.title }}</h3>
              <p>{{ message.body }}</p>
            </div>
            <div v-if="message?.type == 'delete_account'">
              <h3>{{ message.title }}</h3>
              <p>{{ message.body }}</p>
            </div>
            <div
              class="delete_notification"
              :class="{ read: message.is_read }"
              @click.stop="NotificationsReaded(message.id)"
              v-if="!message.is_read"
            >
              <i class="fas fa-check-double"></i>
            </div>
            <div
              class="delete_notification"
              :class="{ read: message.is_read }"
              style="cursor: default"
              v-if="message.is_read"
            >
              <i class="fas fa-check-double"></i>
            </div>
          </div>
        </transition-group>

        <p class="text-danger text-center text--darken-4 pt-5 pb-5" v-else>
          {{ $t("PLACEHOLDERS.no_notifications") }}
        </p>

        <!-- Start:: Pagination -->
        <template>
          <div class="pagination_container text-center mt-3 mb-0">
            <v-pagination
              class="py-0"
              square
              v-model="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="6"
              @input="updateRouterQueryParam($event)"
              :prev-icon="
                getAppLocale == 'ar'
                  ? 'fal fa-angle-right'
                  : 'fal fa-angle-left'
              "
              :next-icon="
                getAppLocale == 'ar'
                  ? 'fal fa-angle-left'
                  : 'fal fa-angle-right'
              "
            />
          </div>
        </template>
        <!-- End:: Pagination -->
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CreateContact",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      isMarkingAllAsRead: false,
      // End:: Loader Control Data

      receivedMessages: [],

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      notificationsData: "NotificationsModule/notificationsData",
    }),
    hasUnreadMessages() {
      return this.receivedMessages.some((msg) => !msg.is_read);
    },
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.getData();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    ...mapActions({
      readAllNotifications: "NotificationsModule/readAllNotifications",
    }),
    openNotify({ id, notification_type }) {
      if (notification_type == "booking_golden_unit") {
        this.$router.push(`/orders-golden-units/show/${id}`);
      } else if (notification_type == "booking_provider_unit") {
        this.$router.push(`/orders-provider-units/show/${id}`);
      } else if (notification_type == "distinction") {
        this.$router.push(`/orders-distinction/show/${id}`);
      } else if (notification_type == "add_unit") {
        this.$router.push(`/orders-units/show/${id}`);
      }
    },
    async markAllAsRead() {
      this.isMarkingAllAsRead = true;
      try {
       let res = await this.$axios({
          method: "POST",
          url: "notification/make-as-read",
        });
        this.$message.success(res.data.message);

        // Update local state
        this.receivedMessages.forEach((msg) => {
          msg.is_read = true;
        });

        // Refresh data and update notification count
        this.getData();
        this.readAllNotifications();
        this.isMarkingAllAsRead = false;
      } catch (error) {
        this.isMarkingAllAsRead = false;
        this.$message.error(
          error?.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
    async getData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "notification/user-notifications",
          params: {
            page: this.paginations.current_page,
          },
        });
        this.receivedMessages = res.data.data.data;
        this.paginations.last_page = res.data.data.meta.last_page;
        this.paginations.items_per_page = res.data.data.meta.per_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    // async DeleteNotification(item_id) {
    //   const REQUEST_DATA = new FormData();
    //   REQUEST_DATA.append("_method", "PUT");
    //   try {
    //     let res = await this.$axios({
    //       method: "POST",
    //       url: `notifications/${item_id}`,
    //       params: REQUEST_DATA,
    //     });
    //     this.$message.success(res.data.message);
    //     this.getData();
    //   } catch (error) {
    //     this.dialogDelete = false;
    //     this.$message.error(error.response.data.errors);
    //   }
    // },

    async NotificationsReaded(item_id) {
      try {
        const REQUEST_DATA = new FormData();
        REQUEST_DATA.append("notification_id", item_id);

        let res = await this.$axios({
          method: "POST",
          url: `notification/make-as-read`,
          data: REQUEST_DATA,
        });

        this.$message.success(res.data.message);
        // Update the local state for the specific message
        const message = this.receivedMessages?.find(
          (msg) => msg.id === item_id
        );
        if (message) {
          message.is_read = true;
        }

        this.getData();
        this.readAllNotifications();
        this.notificationsData.unreadNotifications--;
      } catch (error) {
        this.$message.error(error.response.data.errors);
      }
    },
    hasRedirectPath(message) {
      return !!this.getRedirectPath(message);
    },
    async handleNotificationClick(event, message) {
      // Prevent if clicking on delete_notification icon
      if (event.target.closest(".delete_notification")) {
        return;
      }

      // Mark as read first if not already read
      if (!message.is_read) {
        await this.NotificationsReaded(message.id);
      }

      // Then redirect if there's a redirect path
      const redirectPath = this.getRedirectPath(message);
      if (redirectPath) {
        this.$router.push(redirectPath);
      }
    },
    getRedirectPath(message) {
      if (message?.type == "delete_account") {
        return null;
      }

      if (message?.type === "contact_us") {
        return "/contact-messages/all";
      } else if (message?.type === "new_client") {
        return `/Clients/show/${message?.redirect_id}`;
      } else if (
        message?.type === "create_order" ||
        message?.type === "create_offer"
      ) {
        return `/orders-and-quotations/show/${message?.redirect_id}`;
      } else if (message?.type === "Chat" || message?.type === "open_chat") {
        return `/live-chat/chat/${message?.redirect_id}`;
      }

      return null;
    },
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
  },

  created() {
    this.getData();

    navigator.serviceWorker.addEventListener("message", (event) => {
      const receivedMessage = event.data.data;

      this.receivedMessages.unshift(receivedMessage);
      this.getData();
      this.readAllNotifications();
      this.notificationsData.unreadNotifications--;

      console.log(event.data.data);
      // console.log("receivedMessage", event)
      // Update component state or display the received message in the UI
    });

    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.mark_all_read_wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;

  .mark_all_read_btn {
    min-width: 280px;
  }
}

.show_order {
  cursor: pointer;
  i {
    font-size: 20px;
    position: absolute;
    top: 20px;
    left: 60px;
  }
}
.notification {
  background: #000;
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 20px;
  position: relative;

  &.clickable {
    cursor: pointer;
  }

  .delete_notification {
    position: absolute;
    z-index: 500 !important;
    top: 20px;
    left: 20px;
    cursor: pointer;

    &.read {
      i {
        color: #49a956;
      }
    }

    i {
      font-size: 20px;
      color: #ddd;
    }
  }
}

.text-danger {
  font-size: 22px;
}
</style>
